module.exports = __webpack_public_path__ + "media/newstyle/images/agbook-logo-496e524c27a83cb5cf150d5bbc6c2f11.png";